(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('header', Header)

    /** @ngInject */
    function Header($window, $timeout, $rootScope, AuthenticationService, HelperService, NotificationService, PATHS, DATA_EVENTS) {
        function HeaderController($scope) {
            const vm = this;

            vm.logout = () => AuthenticationService.logout(true);

            vm.onChangeUnit = () => {
                const currentSelectedUnit = AuthenticationService.getSelectedUnit();

                if (vm.selectedUnit.Id && vm.selectedUnit.Id != currentSelectedUnit.Id) {
                    AuthenticationService
                        .setUnit(vm.selectedUnit.Id)
                        .then(response => {
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                            if (response.error)
                                HelperService.handleStateChangeError(response);
                        }, error => {
                            console.log('error: ', error);
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                            HelperService.handleStateChangeError(error);
                        })
                }
            }

            vm.toggleMenu = () => {
                $rootScope.menuOpen = !$rootScope.menuOpen;
            }

            vm.toggleSelectUnit = () => {
                $rootScope.showSelectUnit = !$rootScope.showSelectUnit;
            }

            vm.toggleNotifications = () => {
                $rootScope.showNotifications = !$rootScope.showNotifications;
            }

            vm.toggleSearch = () => {
                $rootScope.showSearch = !$rootScope.showSearch;
            }

            let removeWatchWindow = angular.element($window).on('resize', () => {
                $rootScope.isMobile = HelperService.isScreenSmaller(991);

                $timeout(() => {
                    vm.isMobile = $rootScope.isMobile;
                });
            });

            $scope.$on('$destroy', () => {
                removeWatchWindow();
            })

            init();

            function getNotificationsCount() {
                const userData = AuthenticationService.getUserData();

                return NotificationService
                    .getCount(userData.Id, userData.Responsibility.Id)
                    .then(success => $rootScope.numberOfNotifications = success,
                        error => HelperService.errorCallback(error));
            }

            function init() {
                const authSelectedUnit = AuthenticationService.getSelectedUnit();

                vm.units = AuthenticationService.getUnits();

                let foundUnit = vm.units.find(unit => (unit.Id == authSelectedUnit.Id));

                if (foundUnit)
                    vm.selectedUnit = foundUnit;

                vm.isMobile = $rootScope.isMobile;

                $rootScope.showNotifications = false;
                $rootScope.showSearch = false;
                $rootScope.menuOpen = vm.menuOpen;

                getNotificationsCount();
            }
        }

        return {
            bindToController: true,
            controller: HeaderController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/header/header.html`
        }
    }
}());